import { motion } from "framer-motion";

export default function Terms() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-orange-50 via-white to-orange-100 min-h-screen py-16 px-6">
      {/* Background Animation */}
      <motion.div
        className="absolute -top-28 left-10 w-96 h-96 bg-orange-300/30 rounded-full blur-3xl"
        animate={{ rotate: [0, 360] }}
        transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
      />
      <motion.div
        className="absolute -bottom-20 right-0 w-96 h-96 bg-blue-300/30 rounded-full blur-3xl"
        animate={{ rotate: [360, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: "linear" }}
      />

      <div className="relative max-w-5xl mx-auto bg-white shadow-2xl rounded-2xl p-10">
        <motion.h1
          className="text-4xl font-bold text-orange-800 mb-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Terms & Conditions
        </motion.h1>
        <p className="text-gray-600 mb-6">
          By using our website and services, you agree to the following terms and conditions. 
          Please read them carefully before proceeding.
        </p>

        <div className="space-y-6 text-gray-700">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-orange-700 mb-2">1. Use of Services</h2>
            <p>
              Our products and services are intended for industrial and professional use only. 
              Unauthorized usage is strictly prohibited.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-orange-700 mb-2">2. Intellectual Property</h2>
            <p>
              All content, designs, and materials on this site are the property of Shree Engineering 
              and cannot be copied or redistributed without written consent.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-orange-700 mb-2">3. Limitation of Liability</h2>
            <p>
              We are not liable for any damages resulting from misuse of our products or services 
              beyond the scope of agreed contracts.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-semibold text-orange-700 mb-2">4. Governing Law</h2>
            <p>
              These terms shall be governed by and interpreted in accordance with Indian law. 
              Any disputes will be subject to the jurisdiction of Bangalore courts.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
